import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ChevronLeft, ChevronRight, Calendar, Tag } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function LatestPostsCarousel() {
  const [articles, setArticles] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/articles`).then(res => {
      setArticles(res.data.slice(0, 4));
    }).catch(() => {});
  }, []);

  const scroll = (dir) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: dir * 340, behavior: 'smooth' });
    }
  };

  if (articles.length === 0) return null;

  return (
    <section id="blog" className="py-20 px-6 bg-white" data-testid="latest-posts-carousel">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-rose-600">Blog</span>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-3 text-slate-900">Últimos artículos</h2>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button onClick={() => scroll(-1)} className="w-10 h-10 border border-slate-200 flex items-center justify-center hover:border-slate-400 transition" data-testid="carousel-prev">
              <ChevronLeft size={20} />
            </button>
            <button onClick={() => scroll(1)} className="w-10 h-10 border border-slate-200 flex items-center justify-center hover:border-slate-400 transition" data-testid="carousel-next">
              <ChevronRight size={20} />
            </button>
            <Link to="/blog" className="ml-4 text-sm font-semibold text-rose-600 hover:text-rose-700 transition" data-testid="see-all-blog">
              Ver todos
            </Link>
          </div>
        </div>

        <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide" style={{ scrollbarWidth: 'none' }}>
          {articles.map(article => (
            <Link
              to={`/blog/${article.slug}`}
              key={article.id}
              className="flex-shrink-0 w-[300px] sm:w-[320px] snap-start group"
              data-testid={`carousel-card-${article.slug}`}
            >
              <div className="bg-white border border-slate-200 overflow-hidden hover:border-slate-400 transition h-full">
                <div className="h-44 overflow-hidden">
                  <img src={article.imagen} alt={article.titulo} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[10px] font-bold uppercase tracking-wider text-rose-600 flex items-center gap-1">
                      <Tag size={9} />{article.categoria}
                    </span>
                    {article.created_at && (
                      <span className="text-[10px] text-slate-400 flex items-center gap-1">
                        <Calendar size={9} />
                        {new Date(article.created_at).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })}
                      </span>
                    )}
                  </div>
                  <h3 className="font-bold text-slate-900 text-sm line-clamp-2 group-hover:text-rose-600 transition leading-snug">{article.titulo}</h3>
                  <p className="mt-2 text-xs text-slate-500 line-clamp-2">{article.resumen}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 sm:hidden text-center">
          <Link to="/blog" className="text-sm font-semibold text-rose-600 hover:text-rose-700">Ver todos los artículos →</Link>
        </div>
      </div>
    </section>
  );
}
